<template>
  <!--- <PuSkeletonTheme :duration="0.1" color="rgb(22, 23, 25)" highlight="rgb(94 94 94 / 73%)"> --->
<PuSkeletonTheme :duration="0.1" color="rgb(5, 0, 53, 1)" highlight="rgb(27 25 53)">
    <div class="flex items-center">
      <p v-if="total_score">{{ params.value }} / {{ total_score }}  ({{ Math.round((params.value / total_score) * 100) }}%)</p>
      <PuSkeleton v-else class="" style="width: 250px; height: 100%"></PuSkeleton>
    </div>
  </PuSkeletonTheme>
</template>

<script>
export default {
  data () {
    return {
      total_score: null
    }
  },

  created () {

    this.$httpc.get(`simulations/legacy/${this.params.data.simulation_id}`, {
      ttl: 45
    })
      .then(response => {

        if (response.data.data) {
          this.total_score = response.data.data.total_score

        }
      })
      .catch(exception => {

        let error = 'An unknown error occurred loading score details'
        if (exception.response) {
          error = exception.response.data.error.description
        }

        return this.$vs.notify({
          title: 'Failed to author',
          text: error,
          color: 'danger',
          position: 'top-right'
        })
      })

  }
}

</script>
